// eslint-disable-next-line sort-imports
import { permissionTree, RESOURCE_MANTENIMIENTO } from '@/auth/permissions/modules/mantenimientoMaquinariaPg'
import {
    ROUTE_DASHBOARD_MAQUINARIA,
    ROUTE_DASHBOARD_ORDEN_TRABAJO,
    ROUTE_DASHBOARD_POR_MANTENIMIENTO,
} from '@/router/routes/mantenimiento-pg/nombres/dashboard'
import { defineMenu } from '@/utils/menu'

const { dashboard } = permissionTree
export default defineMenu([
    {
        title: 'manprog.subopciones.dashboard_maquinas',
        resource: RESOURCE_MANTENIMIENTO,
        action: dashboard.maquinas,
        route: ROUTE_DASHBOARD_MAQUINARIA,
    },
    {
        title: 'manprog.subopciones.dashboard_ot',
        resource: RESOURCE_MANTENIMIENTO,
        action: dashboard.ordenesTrabajo,
        route: ROUTE_DASHBOARD_ORDEN_TRABAJO,
    },
    {
        title: 'manprog.subopciones.dashboard_por_mantenimiento',
        resource: RESOURCE_MANTENIMIENTO,
        action: dashboard.porMantenimiento,
        route: ROUTE_DASHBOARD_POR_MANTENIMIENTO,
    },
])
